module.exports = __webpack_public_path__ + "static/8-9f5b020d12368ab67cfb47285330e94d.jpg";